import { render, staticRenderFns } from "./ProjectBudgetFields.vue?vue&type=template&id=65c0a1bc"
import script from "./ProjectBudgetFields.vue?vue&type=script&lang=js"
export * from "./ProjectBudgetFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports